import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
const avatarTones = ['bg-coral-wash text-coral-deep', 'bg-gold-wash text-gold-deep', 'bg-leaf-wash text-leaf-deep', 'bg-navy/10 text-navy'];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="bg-paper" data-id="element-256" data-mp="3azt57ofmmxjh">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-257" data-mp="36ziphk218srf">
        <SectionHeading id="testimonials-title" title="Shared by Believers Like You" intro="From welcome tables to everyday errands — here’s how people are using their printables." data-id="element-258" data-mp="31zwap66k34gi" />
        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-259" data-mp="2s28ba2y098s0">
          {testimonials.map((t, i) => <li key={t.name} className="flex flex-col rounded-2xl bg-white p-7 shadow-card ring-1 ring-cream-line" data-id="element-260" data-mp="v8dl5kwqkabv" data-mpi={i}>
              <QuoteIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-261" data-mp="qava9oz5rl18" />
              <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-navy" data-id="element-262" data-mp="h5opb9y5y46w">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-cream-line pt-5" data-id="element-263" data-mp="m5sy0dstxumk">
                <span className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-xl ${avatarTones[i % avatarTones.length]}`} data-id="element-264" data-mp="78ttiyt9yhwb">
                  {t.name.charAt(0)}
                </span>
                <div data-id="element-265" data-mp="zxr38djf76dg">
                  <p className="font-extrabold text-navy" data-id="element-266" data-mp="zyiwvitgiu13">{t.name}</p>
                  <p className="text-sm text-ink-mute" data-id="element-267" data-mp="14u7pf2727anw">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}